import Vue from "vue";
import VueAxios from "vue-axios";
import moment, {HTML5_FMT} from "moment";
import apiConfig from '@/services/apiConfig';
import apiClient from '@/services/apiClient';

const ApiService = {
    init() {
        Vue.use(VueAxios, apiClient);
        Vue.axios.defaults.baseURL = apiConfig.getUrlAgendaServicosApi() + '/api';
        Vue.axios.interceptors.request.use((config) => {
            config.headers.origem = 2;
            config.headers.Authorization = apiConfig.getToken();    
            return config;
        }, (error) => {
            return Promise.reject(error);
        });
    },

    getAgenda(tipo, dataInicio, dataFinal = dataInicio) {
        let pesquisarData = dataInicio === dataFinal ? `${moment(dataInicio).format(moment.HTML5_FMT.DATE)}`
            : `/${moment(dataInicio).format(moment.HTML5_FMT.DATE)}/${moment(dataFinal).format(HTML5_FMT.DATE)}`;
        return Vue.axios.get(`/agenda/${tipo}/${pesquisarData}`);
    },

    getComanda(id) {
        return this.get('/comandas', id);
    },

    query(resource, params = {}, binary = false) {
        return Vue.axios.get(resource, {params: params, responseType: binary ? 'arraybuffer' : undefined});
    },

    get(resource, slug = "") {
        return Vue.axios.get(`${resource}/${slug}`);
    },

    getImage(resource, slug = "") {
        return Vue.axios.get(`${resource}/${slug}`, {responseType: "blob"});
    },

    post(resource, params, options = undefined) {
        return Vue.axios.post(`${resource}`, params, options);
    },

    update(resource, slug, params) {
        return Vue.axios.put(`${resource}/${slug}`, params);
    },

    put(resource, params) {
        return Vue.axios.put(`${resource}`, params);
    },

    delete(resource, params) {
        if (params)
            return Vue.axios.delete(resource, {data:  params});

        return Vue.axios.delete(resource);
    },

    patch(resource, slug, params) {
        return Vue.axios.patch(`${resource}/${slug}`, params)
    }
};

export default ApiService;
